// Bookie · Lojuvard (teal) — variant that renders the
// standalone HTML template (Bukhara-tile heritage feel: deep
// teal #2C7873 + pale teal-soft #D0E5E4 + warm paper, small
// gold accents, Cormorant Garamond display + Cormorant
// Garamond italic body + a single Pinyon Script ampersand,
// Bukhara tulip ornament band repeated across the top of each
// section header) inside a full-bleed iframe. The HTML lives
// at /templates/bookie-teal.html and the customizer script at
// the top of that file reads names/date/venue/etc. from the
// iframe URL and swaps the mocks before first paint.
//
// We pass payload via URL because postMessage would race the
// iframe's first paint and the customizer must run before the
// IntersectionObserver inside the HTML attaches.

import type { VariantProps } from "./types";
import { getLocale } from "@/lib/i18n";

const TEMPLATE_HTML = "/templates/bookie-teal.html";

export function BookieTealStaticVariant({ t, ctx }: VariantProps) {
  const params = new URLSearchParams();
  if (t.names) params.set("names", t.names);
  if (t.date) {
    // Convert dd.mm.yyyy → ISO yyyy-mm-dd for the customizer. The HTML
    // accepts both, but ISO keeps the iframe URL stable across locales.
    const m = t.date.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
    if (m) params.set("date", `${m[3]}-${m[2]}-${m[1]}`);
    else params.set("date", t.date);
  }
  if (t.venue) params.set("venue", t.venue);
  if (t.address) params.set("address", t.address);
  if (t.mapUrl) params.set("map_url", t.mapUrl);
  if (t.time) params.set("time", t.time);
  // Demo / preview surfaces leave ctx.slug undefined.
  if (ctx.slug) params.set("slug", ctx.slug);
  if (t.musicTrackId) params.set("audio", "/music/" + t.musicTrackId + ".mp3");
  // Cache buster — bump when the static HTML changes.
  params.set("v", "4");

  // Demo/catalog preview (no real invitation slug): default the template's
  // in-iframe language to the app locale, so taklifla.com previews render in
  // English (and a RU viewer sees Russian). The HTMLs read ?lang= (all) and
  // ?default_lang= (newer premium ones) — set both. Owner-published
  // invitations (ctx.slug set) keep their own default_lang / built-in default.
  if (!ctx.slug) {
    const _loc = getLocale();
    if (!params.has("lang")) params.set("lang", _loc);
    if (!params.has("default_lang")) params.set("default_lang", _loc);
  }
  const src = `${TEMPLATE_HTML}?${params.toString()}`;

  return (
    <iframe
      src={src}
      title={t.names || "Lojuvard"}
      style={{
        position: "fixed",
        inset: 0,
        width: "100vw",
        height: "100svh",
        border: "none",
        display: "block",
        background: "#FBF6EC",
      }}
    />
  );
}
